export const enforceMaxLength = (e) => {
  if (e.target.value.length === e.target.maxLength) {
    e.preventDefault();
  }
};
